// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation-sidebar {
  width: 60px;
  background: #f8f9fa;
  border-right: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
}
.conversation-sidebar .sidebar-header {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e1e5e9;
}
.conversation-sidebar .sidebar-header .new-chat-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: #007acc;
  color: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.conversation-sidebar .sidebar-header .new-chat-btn:hover {
  background: #005a9e;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.conversation-sidebar .sidebar-header .new-chat-btn.disabled {
  background: #d1d5db;
  cursor: not-allowed;
  opacity: 0.7;
}
.conversation-sidebar .sidebar-header .new-chat-btn.disabled:hover {
  background: #d1d5db;
  transform: none;
  box-shadow: none;
}
.conversation-sidebar .sidebar-header .new-chat-btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  opacity: 0.7;
}
.conversation-sidebar .sidebar-header .new-chat-btn i {
  font-size: 16px;
}
.conversation-sidebar .conversation-list {
  flex: 1;
  padding: 6px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.conversation-sidebar .conversation-list .pagination-btn {
  width: 40px;
  height: 28px;
  border: none;
  background: #1ab394;
  color: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
  flex-shrink: 0;
}
.conversation-sidebar .conversation-list .pagination-btn:hover:not(:disabled) {
  background: #13806a;
}
.conversation-sidebar .conversation-list .pagination-btn:disabled {
  background: #a8e6cf;
  color: #ffffff;
  cursor: default;
  opacity: 0.5;
}
.conversation-sidebar .conversation-list .pagination-btn i {
  font-size: 12px;
}
.conversation-sidebar .conversation-list .conversation-item {
  width: 40px;
  height: 40px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #ffffff;
  transition: all 0.2s ease;
  font-weight: 600;
  color: #374151;
  position: relative;
}
.conversation-sidebar .conversation-list .conversation-item:hover {
  border-color: #007acc;
  color: #007acc;
  transform: scale(1.05);
}
.conversation-sidebar .conversation-list .conversation-item.active {
  background: #007acc;
  border-color: #007acc;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 122, 204, 0.3);
}
.conversation-sidebar .conversation-list .conversation-item.empty {
  border-color: #f0ad4e;
  border-style: dashed;
}
.conversation-sidebar .conversation-list .conversation-item.empty:hover {
  border-color: #d9534f;
}
.conversation-sidebar .conversation-list .conversation-item.empty.active {
  background: #f0ad4e;
  border-color: #f0ad4e;
  color: #ffffff;
}
.conversation-sidebar .conversation-list .conversation-item.loading {
  background-color: rgba(0, 122, 204, 0.05);
  border-left-color: #007acc;
}
.conversation-sidebar .conversation-list .conversation-item.loading .loading-indicator {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #007acc;
}
.conversation-sidebar .conversation-list .conversation-item .conversation-number {
  font-size: 14px;
  font-weight: 600;
}
.conversation-sidebar .conversation-list .conversation-item .conversation-status {
  position: absolute;
  top: -3px;
  right: -3px;
}
.conversation-sidebar .conversation-list .conversation-item .conversation-status .new-indicator {
  color: #ff4444;
  font-size: 8px;
}
.conversation-sidebar .conversation-list .conversation-item .empty-indicator {
  position: absolute;
  bottom: -3px;
  right: -3px;
}
.conversation-sidebar .conversation-list .conversation-item .empty-indicator i {
  color: #f0ad4e;
  font-size: 8px;
  animation: pulse 1.5s infinite;
}
.conversation-sidebar .conversation-list .conversation-item .delete-conversation-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border: none;
  background: #dc3545;
  color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;
  font-size: 10px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.conversation-sidebar .conversation-list .conversation-item .delete-conversation-btn:hover {
  background: #c82333;
  transform: scale(1.1);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}
.conversation-sidebar .conversation-list .conversation-item .delete-conversation-btn:active {
  transform: scale(0.95);
}
.conversation-sidebar .conversation-list .conversation-item .delete-conversation-btn:focus-visible {
  opacity: 1;
  visibility: visible;
}
.conversation-sidebar .conversation-list .conversation-item .delete-conversation-btn i {
  font-size: 10px;
  line-height: 1;
}
.conversation-sidebar .conversation-list .conversation-item:hover .delete-conversation-btn, .conversation-sidebar .conversation-list .conversation-item:focus-within .delete-conversation-btn {
  opacity: 1;
  visibility: visible;
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 100%;
  height: 100%;
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions button {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.15s ease;
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions button i {
  font-size: 10px;
  line-height: 1;
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions .confirm-delete-btn {
  background: #28a745;
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(40, 167, 69, 0.4);
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions .confirm-delete-btn:hover {
  background: #218838;
  transform: scale(1.15);
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions .confirm-delete-btn:active {
  transform: scale(0.95);
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions .cancel-delete-btn {
  background: #dc3545;
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(220, 53, 69, 0.4);
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions .cancel-delete-btn:hover {
  background: #c82333;
  transform: scale(1.15);
}
.conversation-sidebar .conversation-list .conversation-item .delete-confirm-actions .cancel-delete-btn:active {
  transform: scale(0.95);
}
.conversation-sidebar .conversation-list .conversation-item.confirming-delete {
  border-color: #007acc;
  background: #ffffff;
  animation: pulse-border 1.2s ease-in-out infinite;
}
@keyframes pulse-border {
  0%, 100% {
    border-color: #007acc;
  }
  50% {
    border-color: #005a9e;
  }
}
.conversation-sidebar.minimized {
  width: 40px;
}
.conversation-sidebar.minimized .sidebar-header {
  height: 40px;
}
.conversation-sidebar.minimized .sidebar-header .new-chat-btn {
  width: 30px;
  height: 30px;
}
.conversation-sidebar.minimized .sidebar-header .new-chat-btn i {
  font-size: 12px;
}
.conversation-sidebar.minimized .conversation-list {
  padding: 5px 0;
}
.conversation-sidebar.minimized .conversation-list .conversation-item {
  width: 30px;
  height: 30px;
}
.conversation-sidebar.minimized .conversation-list .conversation-item .conversation-number {
  font-size: 12px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 5px;
  font-size: 0.8em;
  color: #007acc;
  text-align: center;
  flex-direction: column;
}
.loading-indicator i {
  margin-right: 5px;
  font-size: 1.2em;
}
.loading-indicator span {
  margin-top: 5px;
  font-size: 0.8em;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@media (max-width: 768px) {
  .conversation-sidebar {
    width: 50px;
  }
  .conversation-sidebar .sidebar-header .new-chat-btn {
    width: 35px;
    height: 35px;
  }
  .conversation-sidebar .sidebar-header .new-chat-btn i {
    font-size: 14px;
  }
  .conversation-sidebar .conversation-list .conversation-item {
    width: 35px;
    height: 35px;
  }
  .conversation-sidebar .conversation-list .conversation-item .conversation-number {
    font-size: 12px;
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/angularApp/components/wings-assistant-chat/wings-conversation-list.scss"],"names":[],"mappings":"AAYA;EACE,WAAA;EACA,mBAPiB;EAQjB,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AAXF;AAaE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAXJ;AAaI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBA9BU;EA+BV,cAzBE;EA0BF,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAXN;AAaM;EACE,mBAvCO;EAwCP,sBAAA;EACA,wCAAA;AAXR;AAcM;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAZR;AAcQ;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAZV;AAgBM;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AAdR;AAiBM;EACE,eAAA;AAfR;AAoBE;EACE,OAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAlBJ;AAqBI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,cAAA;AAnBN;AAqBM;EACE,mBAAA;AAnBR;AAsBM;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AApBR;AAuBM;EACE,eAAA;AArBR;AAyBI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAjHE;EAkHF,yBAAA;EACA,gBAAA;EACA,cAvHO;EAwHP,kBAAA;AAvBN;AAyBM;EACE,qBA9HQ;EA+HR,cA/HQ;EAgIR,sBAAA;AAvBR;AA0BM;EACE,mBApIQ;EAqIR,qBArIQ;EAsIR,cAhIA;EAiIA,4CAAA;AAxBR;AA2BM;EACE,qBAAA;EACA,oBAAA;AAzBR;AA2BQ;EACE,qBAAA;AAzBV;AA4BQ;EACE,mBAAA;EACA,qBAAA;EACA,cA/IF;AAqHR;AA+BM;EACE,yCAAA;EACA,0BA5JQ;AA+HhB;AA+BQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAvKM;AA0IhB;AAiCM;EACE,eAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAhCR;AAkCQ;EACE,cAAA;EACA,cAAA;AAhCV;AAoCM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAlCR;AAoCQ;EACE,cAAA;EACA,cAAA;EACA,8BAAA;AAlCV;AAuCM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,cA1MA;EA2MA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;AArCR;AAuCQ;EACE,mBAAA;EACA,qBAAA;EACA,wCAAA;AArCV;AAwCQ;EACE,sBAAA;AAtCV;AAyCQ;EACE,UAAA;EACA,mBAAA;AAvCV;AA0CQ;EACE,eAAA;EACA,cAAA;AAxCV;AA6CM;EAEE,UAAA;EACA,mBAAA;AA5CR;AAgDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AA9CR;AAgDQ;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,0BAAA;AA9CV;AAgDU;EACE,eAAA;EACA,cAAA;AA9CZ;AAkDQ;EACE,mBAAA;EACA,cAjRF;EAkRE,4CAAA;AAhDV;AAkDU;EACE,mBAAA;EACA,sBAAA;AAhDZ;AAmDU;EACE,sBAAA;AAjDZ;AAqDQ;EACE,mBAAA;EACA,cAhSF;EAiSE,4CAAA;AAnDV;AAqDU;EACE,mBAAA;EACA,sBAAA;AAnDZ;AAsDU;EACE,sBAAA;AApDZ;AA0DM;EACE,qBAtTQ;EAuTR,mBAjTA;EAkTA,iDAAA;AAxDR;AA4DI;EACE;IAAW,qBA7TD;EAoQd;EA0DI;IAAM,qBA7TG;EAsQb;AACF;AA2DE;EACE,WAAA;AAzDJ;AA2DI;EACE,YAAA;AAzDN;AA2DM;EACE,WAAA;EACA,YAAA;AAzDR;AA2DQ;EACE,eAAA;AAzDV;AA8DI;EACE,cAAA;AA5DN;AA8DM;EACE,WAAA;EACA,YAAA;AA5DR;AA8DQ;EACE,eAAA;AA5DV;;AAoEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAzWc;EA0Wd,kBAAA;EACA,sBAAA;AAjEF;AAmEE;EACE,iBAAA;EACA,gBAAA;AAjEJ;AAoEE;EACE,eAAA;EACA,gBAAA;AAlEJ;;AAuEA;EACE;IACE,UAAA;EApEF;EAsEA;IACE,YAAA;EApEF;AACF;AAwEA;EACE;IACE,WAAA;EAtEF;EAwEE;IACE,WAAA;IACA,YAAA;EAtEJ;EAwEI;IACE,eAAA;EAtEN;EA0EE;IACE,WAAA;IACA,YAAA;EAxEJ;EA0EI;IACE,eAAA;EAxEN;AACF;AA8EA;EACE;IACE,UAAA;EA5EF;EA8EA;IACE,YAAA;EA5EF;AACF","sourcesContent":["// Wings Conversation List Component Styles\n// Importando as mesmas variáveis do componente principal\n$primary-color: #007acc; // Usando o azul que já estava no componente\n$primary-dark: #005a9e;\n$secondary-color: #ebebeb;\n$text-color: #374151;\n$border-color: #e1e5e9;\n$background-light: #f8f9fa;\n$white: #ffffff;\n$shadow-color: rgba(0, 0, 0, 0.1);\n$shadow-color-strong: rgba(0, 0, 0, 0.2);\n\n.conversation-sidebar {\n  width: 60px;\n  background: $background-light;\n  border-right: 1px solid $border-color;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0; // Impede que a barra lateral seja comprimida\n  height: 100%; // Garante que ocupe toda a altura do container pai\n\n  .sidebar-header {\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-bottom: 1px solid $border-color;\n\n    .new-chat-btn {\n      width: 40px;\n      height: 40px;\n      border: none;\n      background: $primary-color;\n      color: $white;\n      border-radius: 8px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: $primary-dark;\n        transform: scale(1.05);\n        box-shadow: 0 2px 8px $shadow-color;\n      }\n\n      &.disabled {\n        background: #d1d5db;\n        cursor: not-allowed;\n        opacity: 0.7;\n        \n        &:hover {\n          background: #d1d5db;\n          transform: none;\n          box-shadow: none;\n        }\n      }\n      \n      &:disabled {\n        background: #d1d5db;\n        cursor: not-allowed;\n        opacity: 0.7;\n      }\n\n      i {\n        font-size: 16px;\n      }\n    }\n  }\n\n  .conversation-list {\n    flex: 1;\n    padding: 6px 0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n\n    // Botões de paginação (setas)\n    .pagination-btn {\n      width: 40px;\n      height: 28px;\n      border: none;\n      background: #1ab394;\n      color: #ffffff;\n      border-radius: 6px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n      padding: 0;\n      flex-shrink: 0;\n\n      &:hover:not(:disabled) {\n        background: #13806a;\n      }\n\n      &:disabled {\n        background: #a8e6cf;\n        color: #ffffff;\n        cursor: default;\n        opacity: 0.5;\n      }\n\n      i {\n        font-size: 12px;\n      }\n    }\n\n    .conversation-item {\n      width: 40px;\n      height: 40px;\n      border: 2px solid $border-color;\n      border-radius: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      background: $white;\n      transition: all 0.2s ease;\n      font-weight: 600;\n      color: $text-color;\n      position: relative;\n\n      &:hover {\n        border-color: $primary-color;\n        color: $primary-color;\n        transform: scale(1.05);\n      }\n\n      &.active {\n        background: $primary-color;\n        border-color: $primary-color;\n        color: $white;\n        box-shadow: 0 2px 8px rgba(0, 122, 204, 0.3);\n      }\n      \n      &.empty {\n        border-color: #f0ad4e;\n        border-style: dashed;\n        \n        &:hover {\n          border-color: #d9534f;\n        }\n        \n        &.active {\n          background: #f0ad4e;\n          border-color: #f0ad4e;\n          color: $white;\n        }\n      }\n\n      // Adicionar estilos para quando a conversa está sendo carregada\n      &.loading {\n        background-color: rgba($primary-color, 0.05);\n        border-left-color: $primary-color;\n        \n        .loading-indicator {\n          position: absolute;\n          right: 8px;\n          top: 50%;\n          transform: translateY(-50%);\n          font-size: 0.8em;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: $primary-color;\n        }\n      }\n\n      .conversation-number {\n        font-size: 14px;\n        font-weight: 600;\n      }\n\n      .conversation-status {\n        position: absolute;\n        top: -3px;\n        right: -3px;\n\n        .new-indicator {\n          color: #ff4444;\n          font-size: 8px;\n        }\n      }\n      \n      .empty-indicator {\n        position: absolute;\n        bottom: -3px;\n        right: -3px;\n        \n        i {\n          color: #f0ad4e;\n          font-size: 8px;\n          animation: pulse 1.5s infinite;\n        }\n      }\n      \n      // Botão de deletar conversa\n      .delete-conversation-btn {\n        position: absolute;\n        top: -6px;\n        right: -6px;\n        width: 18px;\n        height: 18px;\n        border: none;\n        background: #dc3545;\n        color: $white;\n        border-radius: 50%;\n        cursor: pointer;\n        opacity: 0;\n        visibility: hidden;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s ease;\n        padding: 0;\n        font-size: 10px;\n        z-index: 10;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n        \n        &:hover {\n          background: #c82333;\n          transform: scale(1.1);\n          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);\n        }\n        \n        &:active {\n          transform: scale(0.95);\n        }\n        \n        &:focus-visible {\n          opacity: 1;\n          visibility: visible;\n        }\n        \n        i {\n          font-size: 10px;\n          line-height: 1;\n        }\n      }\n      \n      // Mostrar botão de deletar ao passar o mouse ou focar na conversa\n      &:hover .delete-conversation-btn,\n      &:focus-within .delete-conversation-btn {\n        opacity: 1;\n        visibility: visible;\n      }\n      \n      // Confirmação inline de exclusão\n      .delete-confirm-actions {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 2px;\n        width: 100%;\n        height: 100%;\n        \n        button {\n          width: 18px;\n          height: 18px;\n          border: none;\n          border-radius: 50%;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          padding: 0;\n          transition: all 0.15s ease;\n          \n          i {\n            font-size: 10px;\n            line-height: 1;\n          }\n        }\n        \n        .confirm-delete-btn {\n          background: #28a745;\n          color: $white;\n          box-shadow: 0 1px 3px rgba(40, 167, 69, 0.4);\n          \n          &:hover {\n            background: #218838;\n            transform: scale(1.15);\n          }\n          \n          &:active {\n            transform: scale(0.95);\n          }\n        }\n        \n        .cancel-delete-btn {\n          background: #dc3545;\n          color: $white;\n          box-shadow: 0 1px 3px rgba(220, 53, 69, 0.4);\n          \n          &:hover {\n            background: #c82333;\n            transform: scale(1.15);\n          }\n          \n          &:active {\n            transform: scale(0.95);\n          }\n        }\n      }\n      \n      // Quando está em modo de confirmação, fundo branco com contorno azul\n      &.confirming-delete {\n        border-color: $primary-color;\n        background: $white;\n        animation: pulse-border 1.2s ease-in-out infinite;\n      }\n    }\n\n    @keyframes pulse-border {\n      0%, 100% { border-color: $primary-color; }\n      50% { border-color: $primary-dark; }\n    }\n  }\n  \n  // Estilo para quando a barra lateral está minimizada\n  &.minimized {\n    width: 40px;\n    \n    .sidebar-header {\n      height: 40px;\n      \n      .new-chat-btn {\n        width: 30px;\n        height: 30px;\n        \n        i {\n          font-size: 12px;\n        }\n      }\n    }\n    \n    .conversation-list {\n      padding: 5px 0;\n      \n      .conversation-item {\n        width: 30px;\n        height: 30px;\n        \n        .conversation-number {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n\n// Estilos para o indicador de carregamento global\n.loading-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 5px;\n  font-size: 0.8em;\n  color: $primary-color;\n  text-align: center;\n  flex-direction: column;\n  \n  i {\n    margin-right: 5px;\n    font-size: 1.2em;\n  }\n  \n  span {\n    margin-top: 5px;\n    font-size: 0.8em;\n  }\n}\n\n// Animação para indicador de nova conversa\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .conversation-sidebar {\n    width: 50px;\n\n    .sidebar-header .new-chat-btn {\n      width: 35px;\n      height: 35px;\n\n      i {\n        font-size: 14px;\n      }\n    }\n\n    .conversation-list .conversation-item {\n      width: 35px;\n      height: 35px;\n\n      .conversation-number {\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n// Animation for new conversation indicator\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
